import { FC, memo, useMemo } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Description } from '@ucheba/ui/components/Description/desktop'
import { ITextBlockProps } from '../types'

const Block = styled.div``

/* Текстовой блок с заголовком */
const TextBlock: FC<ITextBlockProps> = (props) => {
  const { title, description } = props

  const newText = useMemo(() => {
    if (Array.isArray(description)) return ''

    const jsonText = JSON.stringify(description)

    /** вместо \n подставляем </br> */
    const htmlText = jsonText.replace(/\\n/gm, '</br>')

    return JSON.parse(htmlText)
  }, [description])

  return (
    <Block>
      {title && <Heading h3={title} spacing='small' />}

      {description && (
        <>
          {Array.isArray(description) ? (
            <Description description={description} spacing='xxsmall' />
          ) : (
            <Text>{newText}</Text>
          )}
        </>
      )}
    </Block>
  )
}

export default memo(TextBlock)
